import { STAGE_STYLES } from "@/lib/constants";
import { cn } from "@/lib/utils";

export function StagePill({ stage, className }) {
  const style = STAGE_STYLES[stage] || STAGE_STYLES["On Hold"];
  return (
    <span
      data-testid={`stage-pill-${stage.toLowerCase().replace(/\s+/g, "-")}`}
      className={cn(
        "inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-sm whitespace-nowrap",
        style.light,
        style.dark,
        className
      )}
    >
      {stage}
    </span>
  );
}
